export default __webpack_public_path__ + "static/media/FAO.fbeb4a1b.svg";